import React from "react";
import { Box, HStack, Text, Button, Wrap, WrapItem } from "@chakra-ui/react";
import FilterMenu from "./FilterMenu";

export default function DiscoverHeader({
  category,
  setCategoryId,
  Allcategories,
  products,
  filters,
  setFilters,
  collection
}) {
  // Extract unique tags from the product list
  // const allTags = Array.from(new Set(products.flatMap((p) => p.tags || [])));
  console.log(Allcategories, "Allcategories");
  const handleTagClick = (tag) => {
    setFilters((prev) => ({
      ...prev,
      page: 1, // reset pagination
    }));
    setCategoryId(tag._id);
  };

  return (
    <Box
      pt={28}
      position="sticky"
      top="0"
      bg="white"
      zIndex={10}
      px={4}
      boxShadow="sm"
    >
      <HStack justify="space-between" mb={3}>
        <Box>
          <Text fontSize={22} fontWeight="semibold">
            {collection}
          </Text>
        </Box>

        <FilterMenu
          products={products}
          category={category}
          filters={filters}
          setFilters={setFilters}
        />
      </HStack>

      {/* Tag Filter Buttons */}
      <Wrap spacing={3} my={4}>
        {Allcategories?.filter(
      (item) =>
        ![ "Watch", "Brooches","High Jwellery"].includes(item.name)
    ).map((tag) => (
  <WrapItem key={tag._id}>
    <Button
      size="sm"
      variant={filters.tags === tag.name ? "solid" : "outline"}
      colorScheme="teal"
      onClick={() => handleTagClick(tag)}
      borderRadius="full"
    >
      {tag.name}
    </Button>
  </WrapItem>
))}

      </Wrap>
    </Box>
  );
}
